import React from 'react';
import { cn } from '@/utils';

interface FailureItemProps {
  reason: string;
  count: number;
  maxCount: number;
  index: number;
}

export const FailureItem: React.FC<FailureItemProps> = ({
  reason,
  count,
  maxCount,
  index,
}) => {
  return (
    <div
      className='group cursor-default animate-in slide-in-from-right duration-500'
      style={{ animationDelay: `${index * 100}ms` }}
    >
      <div className='flex justify-between items-start gap-4 mb-2'>
        <span className='text-xs font-bold text-slate-500 leading-tight flex-1 group-hover:text-orange-600 transition-colors'>
          {reason}
        </span>
        <span className='text-sm font-black text-slate-900 tabular-nums bg-slate-100 px-3 py-1 rounded-lg border border-slate-200'>
          {count}
        </span>
      </div>
      <div className='h-3 bg-slate-50 rounded-full overflow-hidden border border-slate-100 shadow-inner'>
        <div
          className={cn(
            'h-full rounded-full transition-all duration-1000 ease-out shadow-sm',
            index === 0
              ? 'bg-gradient-to-r from-orange-500 to-amber-400'
              : 'bg-slate-300 group-hover:bg-slate-400'
          )}
          style={{
            width: `${(count / (maxCount || 1)) * 100}%`,
          }}
        />
      </div>
    </div>
  );
};
